import React from 'react';

import {
  maxCheckListDetails,
  infinityCheckListDetails,
  coreChecklist
} from '../ChecklistsAndContent/content';
import css from '../SetPlan.module.scss';
import CheckListItem from '../../../../components/UI/CheckListItem';

interface Props {
  plan: string;
}

const detailsMapper = {
  infinity: infinityCheckListDetails,
  standard: coreChecklist,
  max: maxCheckListDetails
};

const LearnMoreDetails = ({ plan }: Props) => {
  const details = detailsMapper[plan];
  const headerText = plan === 'core' ? 'Features' : 'Protection & perks';

  return (
    <>
      <p className={css.maxHeader}>{headerText}</p>

      {details.map((item, index) => {
        return (
          <div className={css.maxInfo} key={index}>
            <CheckListItem>
              <h2>{item.heading}</h2>
              <p>{item.details}</p>
            </CheckListItem>
          </div>
        );
      })}
    </>
  );
};

export default LearnMoreDetails;
